import React, { useState, useEffect, useCallback } from "react";
import {
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Skeleton,
} from "@chakra-ui/react";

import { enqueueSnackbar, useSnackbar } from "notistack";
import api from "../../../api";
import { useNavigate, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import NoData from "../../../components/NoData";
import { ClipLoader } from "react-spinners";
import { BiFilter } from "react-icons/bi";

const CustomSkeletonLoader = ({ count }) => {
  const skeletonRows = Array.from({ length: count }, (_, index) => (
    <tr key={index}>
      <td className="text-center" style={{ height: "65px" }}>
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="fs-6 text-center ">
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="fs-6 text-center ">
        <Skeleton width="100%" height="50px" />
      </td>
      <td className="text-center" style={{ cursor: "pointer", width: "40px" }}>
        <Skeleton width="60%" height="25px" />
        <Skeleton width="60%" height="25px" marginTop="10px" />
      </td>
    </tr>
  ));

  return skeletonRows;
};

const LeaveResumption = () => {
  const [page, setPage] = useState(1);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [resultId, setResultId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [pf, setPf] = useState("");
  const [loading, setIsLoading] = useState(false);
  function ToggleDeleteModal(id) {
    setIsDeleteModal(!isDeleteModal);
    setResultId(id);
  }
  function closeDeleteModal() {
    setIsDeleteModal(false);
  }

  const DeleteLeave = async () => {
    setIsLoading(true);

    try {
      const response = await api.deleteLeave(resultId);
      enqueueSnackbar(response?.message, { variant: "success" });
      refetch();
      setIsLoading(false);
      closeDeleteModal(false);
      setResultId("");
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });

      setIsLoading(false);
    }
  };

  const navigate = useNavigate();

  async function getResumption(page) {
    const response = await api.getResumption({
      params: {
        page,
        first_name: firstName,
        last_name: lastName,
        pf_number: pf,
      },
    });
    return response;
  }

  const { isLoading, isError, data, error, isPreviousData, refetch } = useQuery(
    ["leaveRequests", page, firstName, lastName, pf],
    () => getResumption(page),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: "always",
    }
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return (
    <div className="md:p-[20px] p-[10px] bg-[#F2F2F2] min-h-screen ">
      <div className="border-[0.2px] border-[#98a2b3] rounded-[8px]  bg-[#984779] ">
        <div className=" h-full p-[16px] md:p-[20px] block md:flex justify-between items-center md:flex-wrap w-full ">
          <div className="flex items-center gap-[16px]">
            <div className="flex items-center">
              <h3 className="text-[#fff] text-[14px] md:text-[14px] mb-0 xl:text-[16px] font-semibold leading-[24px]  ">
                Resumption Applications
              </h3>
            </div>
         
          </div>

             <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-4 overflow-x-auto custom-scrollbar">
              <BiFilter color="purple" variant="Bold" />
              <input
                type="text"
                placeholder="First Name"
                className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Last Name"
                className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <input
                type="text"
                placeholder="PF Number"
                className="w-full sm:w-[200px] h-[36px] bg-[#F9FAFB] px-2 py-[8px] text-[14px] text-[#344054] leading-[20px] placeholder:text-[#667185] placeholder:text-[12px] border border-[#D0D5DD] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#9326ae] focus:border-[#9326ae]"
                value={pf}
                onChange={(e) => setPf(e.target.value)}
              />
            </div>
        </div>
      </div>
      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <div class="sm:-mx-6 lg:-mx-8 mt-5">
          <div class="inline-block min-w-full  sm:px-6 lg:px-8">
            <div class="overflow-x-auto rounded-lg">
              <table className="min-w-full mb-6 border-[0.8px] border-r-[0.8px]  border-l-[0.8px] border-[#E4E7EC] rounded-lg">
                <thead className="bg-[#F9FAFB]">
                  <tr className="">
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3  gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex px-3 whitespace-nowrap    gap-[6px] md:gap-[12px] items-center">
                        Staff Name
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] px-3  gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex whitespace-nowrap  gap-[6px] md:gap-[12px] ">
                        Leave Type{" "}
                      </div>
                    </th>

                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Status
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Date Applied
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Department
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                    >
                      <div className="flex justify-center gap-[6px] md:gap-[12px] items-center my-0">
                        Action
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && <h3 className="text-sm">Loading....</h3>}
                  {data && data?.data?.length === 0 && <NoData />}

                  {data &&
                    data?.data?.map((item) => (
                      <tr key={item.id} className="mb-2 hover:bg-light-gray">
                        <td className="whitespace-wrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                          <div className="flex items-center  gap-2">
                            <img
                              src={item?.leave?.user_image}
                              className="h-[40px] md:h-[50px] w-[40px] md:w-[50px] rounded-full "
                              alt=""
                            />
                            <div>
                              <p className="mb-0">{item.leave?.full_name}</p>
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center ">
                          {item.leave?.leave_type}
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center  ">
                          <button
                            className={`text-sm font-normal border p-1 px-2 rounded-lg ${
                              item.approval_status === "approved"
                                ? "text-[#388B41] border-[#388B41]"
                                : item.approval_status === "pending"
                                ? "text-[#FFA043] border-[#FFA043]"
                                : item.approval_status === "declined"
                                ? "text-[#FC3400] border-[#FC3400]"
                                : null
                            }`}
                          >
                            {item.approval_status}
                          </button>
                        </td>
                        <td className="whitespace-nowrap py-[10px] bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-center  ">
                          {formatDate(item.created_at)}
                        </td>
                        <td className="whitespace-nowrap py-[10px] text-center bg-white  px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium   ">
                          {item.leave?.department?.name ||
                            item.leave?.faculty?.name ||
                            item.leave?.unit?.name}
                        </td>

                        <td className="whitespace-nowrap py-[16px]  bg-white   px-3  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#1A202C] font-medium text-center  ">
                          <div className="flex items-center gap-3">
                            <Link
                              to={`leave-resumption-details/${item.leave?.id}`}
                              state={item}
                            >
                              <button
                                className="btn py-1 px-3 rounded-0 btn-sm rounded-0 fw-semibold"
                                style={{
                                  border: "1px solid #984779",
                                  color: "#987779",
                                  backgroundColor: "#E9EBFD",
                                }}
                              >
                                View Application
                              </button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden mt-5 space-y-4 ">
        {isLoading && <div className="text-center py-4 text-sm">Loading....</div>}
        {data && data?.data?.length === 0 && <NoData />}
        
        {data &&
          data?.data?.map((item) => (
            <div key={item.id} className="bg-white border border-[#E4E7EC] rounded-lg p-4 shadow-sm">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <img
                    src={item?.leave?.user_image}
                    className="h-[50px] w-[50px] rounded-full object-cover"
                    alt=""
                  />
                  <div>
                    <h3 className="font-semibold text-[#1A202C] text-sm">
                      {item.leave?.full_name}
                    </h3>
                    <p className="text-xs text-[#667185]">{item.leave?.leave_type}</p>
                  </div>
                </div>
                <button
                  className={`text-xs font-normal border px-2 py-1 rounded-lg ${
                    item.approval_status === "approved"
                      ? "text-[#388B41] border-[#388B41]"
                      : item.approval_status === "pending"
                      ? "text-[#FFA043] border-[#FFA043]"
                      : item.approval_status === "declined"
                      ? "text-[#FC3400] border-[#FC3400]"
                      : null
                  }`}
                >
                  {item.approval_status}
                </button>
              </div>
              
              <div className="grid grid-cols-2 gap-3 text-xs mb-4">
                <div>
                  <span className="font-medium text-[#98A2B3]">Date Applied:</span>
                  <p className="text-[#667185]">{formatDate(item.created_at)}</p>
                </div>
                <div>
                  <span className="font-medium text-[#98A2B3]">Department:</span>
                  <p className="text-[#667185]">
                    {item.leave?.department?.name ||
                      item.leave?.faculty?.name ||
                      item.leave?.unit?.name}
                  </p>
                </div>
              </div>
              
              <div className="flex justify-end">
                <Link
                  to={`leave-resumption-details/${item.leave?.id}`}
                  state={item}
                >
                  <button
                    className="text-xs py-2 px-4 rounded border border-[#984779] text-[#984779] bg-[#E9EBFD] hover:bg-[#d4d8f7] transition-colors"
                  >
                    View Application
                  </button>
                </Link>
              </div>
            </div>
          ))}
      </div>
      {/* Pagination */}
      {data && data.data && data?.data?.length > 0 && (
        <div className="px-4 py-4 border-t border-[#E4E7EC] bg-white">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500 text-center sm:text-left">
              <span>
                Showing {data?.meta?.from} - {data.meta?.to} of{" "}
                {data?.meta?.total} results
              </span>
              <span className="mx-2">|</span>
              <span>
                Page {data?.meta?.current_page} of {data?.meta?.last_page}
              </span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={
                  data?.meta?.current_page === 1 || isPreviousData
                }
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Prev
              </button>
              <button
                onClick={() => setPage((prev) => prev + 1)}
                disabled={
                  data?.meta?.current_page === data?.meta?.last_page ||
                  isPreviousData
                }
                className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveResumption;
